import {
  NewsCardCategory,
  NewsCardMobile,
  NewsCardReadmore,
} from '../../../../../packages/ui/features/news/news-card';

import { FC } from 'react';
import { NewsCard } from '../../../../../packages/ui/features/news/news-card';
import { NewsCategoryLink, NewsPostLink } from '../common/link/news-link';
import { Mobile } from '../../../../../packages/ui/components/responsive';
import { NewsData } from '@wwe-portal/entities/news.type';

export const ResponsiveNewsItem: FC<{
  item: NewsData;
}> = ({ item }) => {
  return (
    <Mobile
      fallback={
        <NewsCard
          key={item.id}
          data={item}
          title={<NewsPostLink item={item}>{item.title}</NewsPostLink>}
          category={
            <NewsCategoryLink category={item.category}>
              <NewsCardCategory data={item} />
            </NewsCategoryLink>
          }
          cover={
            <NewsPostLink item={item}>
              {item.imageUrl ? (
                <img
                  src={item.imageUrl}
                  alt="cover"
                  className="absolute h-full w-full object-cover"
                />
              ) : null}
            </NewsPostLink>
          }
          readMore={
            <NewsPostLink item={item}>
              <NewsCardReadmore />
            </NewsPostLink>
          }
        />
      }
    >
      <NewsCardMobile
        key={item.id}
        data={item}
        title={
          <NewsPostLink item={item} className="text-md font-semibold">
            {item.title}
          </NewsPostLink>
        }
        category={
          <NewsCategoryLink category={item.category}>
            <span>#{item.category}</span>
          </NewsCategoryLink>
        }
        cover={
          <NewsPostLink item={item}>
            {item.imageUrl ? (
              <img
                width={70}
                height={0}
                src={item.imageUrl}
                alt="cover"
                className="rounded-md object-cover"
              />
            ) : null}
          </NewsPostLink>
        }
        readMore={
          <NewsPostLink item={item}>
            <NewsCardReadmore />
          </NewsPostLink>
        }
      />
    </Mobile>
  );
};
